(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-pdp-seasonal"] && !Shopify.designMode) return;
  try {
    
function initSeasonal(root){
  if(root.dataset.bound==='true')return;
  root.dataset.bound='true';
  const slides=[...root.querySelectorAll('[data-slide]')];
  const thumbs=[...root.querySelectorAll('[data-thumb]')];
  const variants=[...root.querySelectorAll('[data-variant]')];
  const initialVariantId=variants.find(v=>v.checked)?.value||variants[0]?.value;
  const total=root.querySelector('[data-total]');
  const was=root.querySelector('[data-was]');
  const stock=root.querySelector('[data-stock]');
  const atc=root.querySelector('[data-atc]');
  const empty=root.querySelector('[data-no-media]');
  const prev=root.querySelector('[data-prev]');
  const next=root.querySelector('[data-next]');
  const sticky=root.querySelector('[data-seasonal-sticky]');
  const stickyPrice=root.querySelector('[data-sticky-price]');
  const stickyWas=root.querySelector('[data-sticky-was]');
  const stickyAdd=root.querySelector('[data-sticky-add]');
  let activeIndex=Number(slides.find(s=>!s.hidden)?.dataset.index??-1);
  function visibleIndices(){return slides.filter(s=>s.dataset.filtered!=='true').map(s=>Number(s.dataset.index))}
  function show(index){
    const available=visibleIndices();
    if(!available.length){
      activeIndex=-1;
      slides.forEach(s=>{s.hidden=true});
      thumbs.forEach(t=>{t.setAttribute('aria-pressed','false')});
      if(empty)empty.hidden=false;
      if(prev)prev.hidden=true;
      if(next)next.hidden=true;
      return;
    }
    activeIndex=available.includes(index)?index:available[0];
    slides.forEach(s=>{s.hidden=Number(s.dataset.index)!==activeIndex});
    thumbs.forEach(t=>{t.setAttribute('aria-pressed',String(Number(t.dataset.index)===activeIndex))});
    if(empty)empty.hidden=true;
    if(prev)prev.hidden=available.length<2;
    if(next)next.hidden=available.length<2;
  }
  function selectVariant(v,updateUrl=false){
    if(!v)return;
    const group=v.dataset.group;
    const isMatModels=root.dataset.mode==='mat_models';
    const previousGroup=root.dataset.selectedGroup;
    if(isMatModels){
      root.dataset.selectedGroup=group;
      root.querySelectorAll('.sp-seasonal__hook,.sp-seasonal__points').forEach(el=>{el.hidden=group!=='smooth'});
    }
    slides.forEach(s=>{s.dataset.filtered=isMatModels?(group!=='unmapped'&&s.dataset.group===group?'':'true'):(group==='both'||group==='all'||s.dataset.group===group?'':'true')});
    thumbs.forEach(t=>{t.hidden=isMatModels?(group==='unmapped'||t.dataset.group!==group):!!(group!=='both'&&group!=='all'&&t.dataset.group!==group)});
    const cents=Number(v.dataset.cents||0);
    total.textContent=cents>0?v.dataset.price:'Price coming soon';
    was.textContent=v.dataset.compare||'';
    was.hidden=!v.dataset.compare;
    if(stickyPrice)stickyPrice.textContent=total.textContent;
    if(stickyWas){stickyWas.textContent=was.textContent;stickyWas.hidden=was.hidden}
    const available=v.dataset.available==='true';
    if(stock)stock.textContent=available?'In stock · free shipping':'Currently sold out';
    atc.disabled=cents<=0||!available;
    atc.textContent=cents<=0?'Price coming soon':!available?'Sold out':'Add to cart';
    if(stickyAdd){stickyAdd.disabled=atc.disabled;stickyAdd.textContent=atc.textContent}
    show(visibleIndices()[0]);
    if(isMatModels&&group!==previousGroup){
      const strip=root.querySelector('.sp-seasonal__thumbs');
      if(strip)strip.scrollLeft=0;
    }
    if(isMatModels&&updateUrl&&window.history?.pushState){
      const url=new URL(window.location.href);
      if(url.searchParams.get('variant')!==v.value){
        url.searchParams.set('variant',v.value);
        window.history.pushState(window.history.state,'',url);
      }
    }
  }
  stickyAdd?.addEventListener('click',()=>{if(!atc.disabled)root.querySelector('.sp-seasonal__form')?.requestSubmit(atc)});
  if(sticky&&atc&&'IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>sticky.classList.toggle('is-on',!entry.isIntersecting)),{rootMargin:'0px 0px -10% 0px'});
    observer.observe(atc);
  }
  thumbs.forEach(t=>t.addEventListener('click',()=>show(Number(t.dataset.index))));
  root.querySelector('[data-prev]')?.addEventListener('click',()=>{const ids=visibleIndices();show(ids[(ids.indexOf(activeIndex)-1+ids.length)%ids.length])});
  root.querySelector('[data-next]')?.addEventListener('click',()=>{const ids=visibleIndices();show(ids[(ids.indexOf(activeIndex)+1)%ids.length])});
  variants.forEach(v=>v.addEventListener('change',()=>{if(v.checked)selectVariant(v,true)}));
  if(root.dataset.mode==='mat_models')window.addEventListener('popstate',()=>{
    const id=new URLSearchParams(window.location.search).get('variant');
    const match=variants.find(v=>v.value===(id||initialVariantId))||variants[0];
    if(match){match.checked=true;selectVariant(match)}
  });
  const quantity=root.querySelector('.sp-seasonal__quantity-control input');
  root.querySelectorAll('[data-seasonal-qty]').forEach(button=>button.addEventListener('click',()=>{if(!quantity)return;quantity.value=Math.max(1,(parseInt(quantity.value,10)||1)+Number(button.dataset.seasonalQty));}));
  quantity?.addEventListener('change',()=>{quantity.value=Math.max(1,parseInt(quantity.value,10)||1)});
  const linkedId=root.dataset.mode==='mat_models'?new URLSearchParams(window.location.search).get('variant'):null;
  const linkedVariant=variants.find(v=>v.value===linkedId);
  if(linkedVariant)linkedVariant.checked=true;
  selectVariant(linkedVariant||variants.find(v=>v.checked)||variants[0]);
}
function initAllSeasonal(){document.querySelectorAll('[data-sp-seasonal]').forEach(initSeasonal)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAllSeasonal);else initAllSeasonal();
document.addEventListener('shopify:section:load',initAllSeasonal);

  } catch(e) { console.error(e); }
})();
})();
